import ReactSelect from '../ReactSelect';
import React from 'react';

export const sourceTypeOptions = [
  {
    value: 'POTABLE',
    label: 'Potable',
  },
  {
    value: 'RECYCLED',
    label: 'Recycled',
  },
] as const;

export type SourceType = (typeof sourceTypeOptions)[number]['value'];
export type MultiOnChange = (value?: SourceType[]) => void;
export type OnChange = (value?: SourceType) => void;

export const SourceTypePicker = <IsMulti extends boolean = false>({
  value,
  onChange,
  isMulti,
  isClearable = false,
  isDisabled,
}: {
  isMulti?: IsMulti;
  onChange: IsMulti extends true ? MultiOnChange : OnChange;
  value?: IsMulti extends true ? SourceType[] : SourceType;
  isClearable?: boolean;
  isDisabled?: boolean;
}) => {
  return (
    <ReactSelect
      placeholder="source type"
      isMulti={isMulti}
      isDisabled={isDisabled}
      isClearable={isClearable}
      value={
        isMulti
          ? sourceTypeOptions.filter((option) => value?.includes(option.value))
          : sourceTypeOptions.find((option) => value === option.value)
      }
      styles={{
        menu: (base) => ({
          ...base,
          minWidth: '120px',
        }),
      }}
      onChange={(values) => {
        if (isMulti) {
          (onChange as MultiOnChange)(
            Array.isArray(values)
              ? values.length > 0
                ? values.map((value1) => value1.value as SourceType)
                : undefined
              : undefined
          );
        } else {
          const value =
            (values as (typeof sourceTypeOptions)[number])?.value ?? undefined;
          (onChange as OnChange)(value);
        }
      }}
      options={sourceTypeOptions}
    />
  );
};
